import { Grid, Alert, FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import ControlledTextField from 'src/shared/components/form/controlledTextField';

export const FormatSection = () => {
  const { t } = useTranslation();
  const { getValues } = useFormContext();

  const printZeroInvoice = getValues('printZeroInvoice');
  const householdInvoice = getValues('householdInvoice');

  return (
    <Grid container>
      <Alert icon={false} severity='info' elevation={1}>
        <Grid container mt={1} justifyContent='space-between'>
          <Grid item xs={12} sm={6} mb={1}>
            <ControlledTextField disabled name='formTemplateText' label={t('invoice:adminInvoiceTemplatePage.templateInformation.formTemplate')} />
          </Grid>
          <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <Grid item xs={12}>
              <Grid container sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <FormLabel id='label-printZeroInvoice'>
                  {t('invoice:adminInvoiceTemplatePage.templateInformation.printInvoicesWithZeroAmount')}
                </FormLabel>
                <RadioGroup
                  aria-labelledby='label-printZeroInvoice'
                  name='printZeroInvoice'
                  value={printZeroInvoice}
                  sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', ml: { sm: 0, md: 2 } }}
                >
                  <FormControlLabel
                    sx={{
                      cursor: 'default',
                    }}
                    disabled={!printZeroInvoice}
                    value
                    control={
                      <Radio
                        sx={{
                          pointerEvents: 'none',
                        }}
                      />
                    }
                    label={t('common:button.yes')}
                  />
                  <FormControlLabel
                    sx={{
                      cursor: 'default',
                    }}
                    disabled={printZeroInvoice}
                    value={false}
                    control={
                      <Radio
                        sx={{
                          pointerEvents: 'none',
                        }}
                      />
                    }
                    label={t('common:button.no')}
                  />
                </RadioGroup>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid container sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <FormLabel id='label-householdInvoice'>
                  {t('invoice:adminInvoiceTemplatePage.templateInformation.oneCollectiveInvoicePerHousehold')}
                </FormLabel>
                <RadioGroup
                  aria-labelledby='label-householdInvoice'
                  name='householdInvoice'
                  value={householdInvoice}
                  sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', ml: { sm: 0, md: 2 } }}
                >
                  <FormControlLabel
                    sx={{
                      cursor: 'default',
                    }}
                    disabled={!householdInvoice}
                    value
                    control={
                      <Radio
                        sx={{
                          pointerEvents: 'none',
                        }}
                      />
                    }
                    label={t('common:button.yes')}
                  />
                  <FormControlLabel
                    sx={{
                      cursor: 'default',
                    }}
                    disabled={householdInvoice}
                    value={false}
                    control={
                      <Radio
                        sx={{
                          pointerEvents: 'none',
                        }}
                      />
                    }
                    label={t('common:button.no')}
                  />
                </RadioGroup>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Alert>
    </Grid>
  );
};
